<template>
    <div>
        <header>
            <div class="bloque-cabecera">
                <!-- <div class="logo"></div> -->
            </div>
        </header>
        <br />

        <section>
            <div v-if="paso == '1'" class="bloque-datos">
                <v-row justify="center">
                    <v-col align="center" class="col-12">
                        <menuPage></menuPage>
                    </v-col>
                </v-row>
                <div class="bloque-datos-titulo" style="color: #755e66; font-size: 22px; text-align: center">
                    <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                        Para consultar el estado de tu reparación, solo tienes que cumplimentar los siguientes datos y pulsar el botón Consultar.
                    </p>
                </div>
                <!--<br />
            <div style="text-align: center">
                <a class="reparacion" href="/movistar/reparacion">
                    Solicite una nueva reparación
                </a>
            </div>-->
                <br />
                <div class="bloque-datos-campos">
                    <v-alert v-if="error != ''"
                             dense
                             outlined
                             prominent
                             text
                             :type="tipoTextoIncidencia"
                             style="font-family: Heebo; font-weight: normal">
                        {{ error }}
                    </v-alert>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Código de la Incidencia</div>
                    <div class="row-campos">
                        <input v-model="incidencia.codigo"
                               name="codIncidenia"
                               maxlength="16"
                               id="codIncidenia"
                               class="text-datos"
                               type="text" 
                               style="font-family: Heebo; font-weight: normal"/>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Dirección de Correo de la Incidencia</div>
                    <div class="row-campos">
                        <input v-model="incidencia.mail"
                               name="txtAbonado"
                               maxlength="60"
                               id="txtAbonado"
                               class="text-datos"
                               type="email" 
                               style="font-family: Heebo; font-weight: normal"/>
                    </div>
                    <br />
                    <br />
                    <v-btn :loading="consultando"
                           @click="consultar"
                           color="#9be51a"
                           x-large
                           block>
                        <span style="color: black; font-weight: bold; font-family: Heebo; ">CONSULTAR</span>
                    </v-btn>
                </div>
            </div>

            <div v-if="paso == '2'" class="bloque-datos">
                <div style="color: #755e66; font-size: 22px; text-align: center">
                    <h2 style="font-family: Heebo; font-weight: normal">Avances de la incidencia: {{ incidencia.codigo }}</h2>
                </div>
                <br />
                <br />
                <div class="bloque-datos-campos" v-if="hayLineas">
                    <div style="padding-bottom: 12px; font-size: 1.5em; text-align: justify;font-family: Heebo; font-weight: normal"
                         v-for="(item, key) in lineas"
                         :key="key">
                        {{ getFechaFormateada(item.fecha) }}
                        <div style="font-size: 1.5em; font-family: Heebo; font-weight: normal">
                            {{ item.linea }}
                        </div>
                        <br />
                    </div>
                </div>
                <div v-else class="bloque-datos-campos">
                    <div style="font-size: 2rem; font-family: Heebo; font-weight: normal">
                        Aún no hay avances en la incidencia.
                    </div>
                </div>
                <br />
                <br />
                <div style="text-align: center; font-size: 2em; font-family: Heebo; font-weight: normal">
                    <strong>
                        Si tiene cualquier consulta puede acercarse a cualquier tienda
                        Movistar o enviarnos un correo electrónico a:
                        <div style="color: #00ff00 ;font-family: Heebo; font-weight: normal">r2r.sat@zeleris.com</div>
                    </strong>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import incidencia_formulario from "@/Modelos/IncidenciaFormulario";

    export default {
        layout: "movistar",
        components: {
            menuPage: () => import("@/components/reacondicionados/menu"),
        },
        data: () => ({
            incidencia: {
                codigo: "",
                mail: "",
            },

            error: "",
            tipoTextoIncidencia: "",

            consultando: false,

            paso: "1",

            lineas: [],
        }),

        methods: {
            consultar() {
                this.consultando = true;
                try {
                    this.$API.getlineasPublicasEstados(this.incidencia).then((response) => {
                        if (response.codigo == 0) {
                            this.lineas = response.lineas;

                            this.paso = "2";
                        }
                    });
                } catch (error) {
                    console.log(error);
                } finally {
                    this.consultando = false;
                }
            },
            getFechaFormateada(fecha) {
                let date = new Date(fecha);
                return (
                    date.getDate().toString().padStart(2, "0") +
                    "/" +
                    (date.getMonth() + 1).toString().padStart(2, "0") +
                    "/" +
                    date.getFullYear()
                );
            },
        },
        computed: {
            hayLineas() {
                return this.lineas.length > 0;
            },
        },
    };
</script>

<style>
    .reparacion {
        color: #869296;
        font-size: 20px;
    }

        .reparacion:hover {
            color: rgb(78, 168, 0);
        }
</style>